import { render, staticRenderFns } from "./PostCodeDialog.vue?vue&type=template&id=7689c920&"
import script from "./PostCodeDialog.vue?vue&type=script&lang=js&"
export * from "./PostCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports